import { setSiftUserId, trackEvent, getSiftSessionId } from '@/plugins/sift'

/**
 * Handle Sift user identification and event tracking
 * @param {string} userId - stable unique identifier (customer_id or email)
 * @param {string} eventName - logical event name ('login', 'create_account', 'signup_success')
 * @param {object} extraData - optional metadata (e.g. email)
 */
export function handleSiftLogin(userId, eventName = 'login', extraData = {}) {
  if (!userId) return

  // Always set the user ID
  setSiftUserId(userId)

  // Attach session ID if available
  const sessionId = getSiftSessionId()
  const payload = {
    $user_id: userId,
    ...extraData,
  }
  if (sessionId) {
    payload.session_id = sessionId
  }

  // Map logical events to Sift’s event types
  const eventMap = {
    login: '$login',
    create_account: 'create_account',
    signup_success: 'signup_success',
  }

  const siftEvent = eventMap[eventName] || '$login'
  // Fire the event
  try {
    trackEvent(siftEvent, payload)
  } catch (e) {
    console.warn('[SIFT] Tracking failed:', e)
  }
}